import { useSuspenseQuery } from '@tanstack/react-query';

import { availablePackagesOptions } from './availablePackages.options';

export function useAvailablePackages() {
  return useSuspenseQuery(availablePackagesOptions());
}
